<!-- 论文初稿 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 36.06">
    <title>论文初稿</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="27.46" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="27.46" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="9.23" y1="5.93" x2="15.56" y2="5.93" />
        <line class="cls-4" x1="19.45" y1="12.66" x2="24.6" y2="12.66" />
        <line class="cls-4" x1="9.22" y1="17.58" x2="24.6" y2="17.58" />
        <line class="cls-3" x1="12.26" y1="5.93" x2="12.26" y2="10.98" />
        <path
          class="cls-5"
          d="M4.88,3.51V2.19A1,1,0,0,1,6,1.22L20,1.25a1,1,0,0,1,1.09,1l-.05,5.3a1,1,0,0,0,1.08,1l6.39.06a1,1,0,0,1,1.08,1v18"
        />
        <path class="cls-4" d="M29.1,27.55h-23A1.07,1.07,0,0,1,5,26.49V9.74" />
        <line class="cls-6" x1="20.72" y1="1.22" x2="29.19" y2="8.51" />
        <ellipse class="cls-7" cx="5.01" cy="6.46" rx="1.11" ry="1.08" />
        <line class="cls-4" x1="9.22" y1="22.5" x2="24.6" y2="22.5" />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 36.04">
    <title>论文初稿</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="27.44" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="27.44" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="9.23" y1="5.91" x2="15.56" y2="5.91" />
        <line class="cls-3" x1="19.45" y1="12.64" x2="24.6" y2="12.64" />
        <line class="cls-3" x1="9.22" y1="17.56" x2="24.6" y2="17.56" />
        <line class="cls-3" x1="12.26" y1="5.91" x2="12.26" y2="10.96" />
        <path
          class="cls-3"
          d="M4.88,3.49V2.17A1,1,0,0,1,6,1.2L20,1.23a1,1,0,0,1,1.09,1l-.05,5.3a1,1,0,0,0,1.08,1l6.39.06a1,1,0,0,1,1.08,1v18"
        />
        <path class="cls-3" d="M29.1,27.53h-23A1.06,1.06,0,0,1,5,26.47V9.72" />
        <line class="cls-3" x1="20.72" y1="1.2" x2="29.19" y2="8.49" />
        <ellipse class="cls-4" cx="5.01" cy="6.44" rx="1.11" ry="1.08" />
        <line class="cls-3" x1="9.22" y1="22.48" x2="24.6" y2="22.48" />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 36.78">
    <title>论文初稿</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="28.18" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="28.18" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="9.61" y1="5.82" x2="16.19" y2="5.82" />
        <line class="cls-3" x1="20.24" y1="12.81" x2="25.59" y2="12.81" />
        <line class="cls-3" x1="9.6" y1="17.93" x2="25.59" y2="17.93" />
        <line class="cls-3" x1="12.76" y1="5.82" x2="12.76" y2="11.07" />
        <path
          class="cls-3"
          d="M5.09,3.3V1.93a1.08,1.08,0,0,1,1.13-1L20.85,1A1.08,1.08,0,0,1,22,2l-.05,5.51a1.08,1.08,0,0,0,1.12,1l6.65.06a1.08,1.08,0,0,1,1.12,1V28.31"
        />
        <path
          class="cls-3"
          d="M30.27,28.3H6.36a1.11,1.11,0,0,1-1.11-1.1V9.78"
        />
        <line class="cls-3" x1="21.55" y1="0.92" x2="30.37" y2="8.5" />
        <ellipse class="cls-4" cx="5.22" cy="6.36" rx="1.16" ry="1.12" />
        <line class="cls-3" x1="9.6" y1="23.05" x2="25.59" y2="23.05" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3,
    .cls-4,
    .cls-5 {
      fill: none;
    }
    .cls-3,
    .cls-4,
    .cls-5,
    .cls-6 {
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-3 {
      stroke-width: 2.4px;
    }
    .cls-4,
    .cls-6 {
      stroke-width: 2.44px;
    }
    .cls-5 {
      stroke-width: 2.44px;
    }
    .cls-6 {
      fill: #1ba586;
    }
    .cls-7 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.4px;
    }
    .cls-4 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3 {
      fill: none;
      stroke: #34aa91;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.84px;
    }
    .cls-4 {
      fill: #34aa91;
    }
  }
</style>
